import { render, staticRenderFns } from "./Cosmetics.vue?vue&type=template&id=e35e5d32&scoped=true&"
import script from "./Cosmetics.vue?vue&type=script&lang=js&"
export * from "./Cosmetics.vue?vue&type=script&lang=js&"
import style0 from "./Cosmetics.vue?vue&type=style&index=0&id=e35e5d32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35e5d32",
  null
  
)

export default component.exports